module.exports = __webpack_public_path__ + "img/partner_57.c59aa141.png";